let BaseLogic = require("clover/gamePlay/startEndLevelLogic/StartMainLevelLogic")
let StartMysteryIslandLevelLogic = xClass("StartMysteryIslandLevelLogic",BaseLogic )
StartMysteryIslandLevelLogic.create = function (levelId, extraData) {
    let self = this
    // body
    let [success, errCode] = self.prototype.checkCanStart(levelId)
    if (!success) {
        // FIXME: multi result
        return [null, errCode]
    }

    return [StartMysteryIslandLevelLogic.new(levelId, extraData), undefined]
}
// 检查是否能进入关卡
StartMysteryIslandLevelLogic.prototype.checkCanStart = function (levelId) {
    return [true, undefined]
}
// StartMysteryIslandLevelLogic.prototype.ctor = function (levelId, extraData = {}) {
//     var self = this

// }
StartMysteryIslandLevelLogic.prototype.start = function (successCallback, failCallback, needPanel = true, isReplay) {
    let self = this
    if (self.isBusy) {
        return 
    }
    self.mysteryIsland = clone(MysteryIslandManager.getInstance().getLevelInfo())
    // self.__start(successCallback, failCallback, extraCallback, self.isOpenedFromQuitPanel && "replayLevel" || null)
    // self.start(successCallback, failCallback)

    // self.mysteryIsland = {
    //     levelNo: 3000
    // }

    BaseLogic.prototype.start.call(self,successCallback, failCallback, needPanel, isReplay);

}

StartMysteryIslandLevelLogic.prototype.createStartPanel = function () {
    // let __VA_ARG = $slice(arguments, 0)
    // let self = this
    // [StartPanel, StartPanelEvent] = unpack(require("clover/panel/MysteryIslandStartPanel"))
    // // WARN: maybe multi result
    // return StartPanel.create(...__VA_ARG)
    [StartPanel, StartPanelEvent] = unpack(require("clover/panel/MysteryIslandStartPanel"))
    // // WARN: maybe multi result
    // return StartPanel.create(...__VA_ARG)
    return  [StartPanel, StartPanelEvent] 
}

StartMysteryIslandLevelLogic.prototype.levelInfo = function () {
    var self = this
    var ret = table([1, "gameplayMode", LevelConfigManager.getInstance().getLevelGameMode(self.levelId)])
    var levelType = LevelType.getLevelTypeByLevelId(self.levelId)
    
    if (levelType !== GameLevelType.kMainLevel && levelType !== GameLevelType.kMysteryIsland) {
        ret.levelType = levelType
        ret.hellFlag = 0
    } else if (levelType === GameLevelType.kMysteryIsland) {
        ret.levelId = self.mysteryIsland.levelNo
        ret.hellFlag = 0
    } else {
        ret.levelId = self.levelId
        ret.hellFlag = levelConfig && levelConfig.hellFlag || 0
    }
    return ret
}
module.exports = StartMysteryIslandLevelLogic
